import { render, staticRenderFns } from "./ScoreboardLayout.vue?vue&type=template&id=20444aea&scoped=true&"
import script from "./ScoreboardLayout.vue?vue&type=script&lang=js&"
export * from "./ScoreboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardLayout.vue?vue&type=style&index=0&id=20444aea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20444aea",
  null
  
)

export default component.exports